import React, { useEffect } from 'react';
import { AppraiserAllocation } from 'interface/createUpdateForm';

import { LIST_TYPE } from 'constants/appConstants';
import AvatarComponent from 'components/common/avatar/AvatarComponent';
import DebounceFormDropdown from 'components/common/debounceFormDropdown/DebounceFormDropdown';
import { COMPLETE, ERROR, APPRAISER_ALLOCATION_FORM_INPUTS } from 'constants/createEmployeeForm';

interface StepperFormState {
  id: number;
  state: string;
}

interface AppraiserAllocationFormProps {
  errors: Partial<Record<keyof AppraiserAllocation, string>>;
  values: AppraiserAllocation;
  touched: Partial<Record<keyof AppraiserAllocation, boolean>>;
  handleChange: (event: { target: { name: string; value: string | number | Array<string | number> | null } }) => void;
  handleBlur: (event: { target: { name: string } }) => void;
  currentForm?: StepperFormState;
  setCurrentFormState?: (state: string) => void;
  shouldForcefullyShowError: boolean;
  appraiserDebounceOptions: React.ComponentProps<typeof DebounceFormDropdown>['debounceOptions'];
  coAppraiserDebounceOptions: React.ComponentProps<typeof DebounceFormDropdown>['debounceOptions'];
}

const AppraiserAllocationForm: React.FC<AppraiserAllocationFormProps> = (props) => {
  const {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
    currentForm,
    setCurrentFormState,
    shouldForcefullyShowError,
  } = props;

  const { appraiserDebounceOptions, coAppraiserDebounceOptions } = props;

  useEffect(() => {
    if (currentForm) {
      const isFormEmpty = APPRAISER_ALLOCATION_FORM_INPUTS.some((key) => {
        if (!values[key]) {
          return true;
        }
        return false;
      });

      if (!isFormEmpty) {
        setCurrentFormState?.(COMPLETE);
        return;
      }
      setCurrentFormState?.(ERROR);
    }
  }, [currentForm, setCurrentFormState, values]);

  return (
    <div className="office-information-form ">
      <div className="office-information-form__full-width">
        <div className="office-information-form__full-width__space">
          <DebounceFormDropdown
            isMandatory
            name="appraiserId"
            label="Appraiser"
            type={LIST_TYPE.EMPLOYEE}
            value={values.appraiserId}
            error={(shouldForcefullyShowError || touched.appraiserId) && errors.appraiserId}
            debounceOptions={appraiserDebounceOptions}
            handleChange={handleChange}
            handleBlur={handleBlur}
            iconComponent={(option) => (
              <AvatarComponent label={String(option.label || '')} value={option as { empId?: string | number }} />
            )}
            isClearable={true}
            className="employee-form__dropdown"
          />
        </div>
        <div className="office-information-form__full-width__space">
          <DebounceFormDropdown
            name="coAppraiserId"
            label="Co Appraiser"
            type={LIST_TYPE.EMPLOYEE}
            value={values.coAppraiserId}
            error={(shouldForcefullyShowError || touched.coAppraiserId) && errors.coAppraiserId}
            handleChange={handleChange}
            debounceOptions={coAppraiserDebounceOptions}
            handleBlur={handleBlur}
            iconComponent={(option) => (
              <AvatarComponent label={String(option.label || '')} value={option as { empId?: string | number }} />
            )}
            isClearable={true}
            className="employee-form__dropdown"
          />
        </div>
      </div>
    </div>
  );
};

export default AppraiserAllocationForm;
